import { AIReviewPanel } from '../ops/AIReviewPanel';

// AIReviewPage: projektweite Prüfqueue der KI-Vorschläge (Support, Teamleitung).
export function AIReviewPage({ embedded = false, contactOnly = false }: { embedded?: boolean; contactOnly?: boolean }) {
  return (
    <div className={embedded ? 'embedded-page' : 'page'}>
      <header className="page-header">
        {!embedded && <h1>KI-Prüfung</h1>}
        <span className="muted">
          {contactOnly
            ? 'Kontaktdaten, die die KI in Gesprächen gehört hat – übernehmen oder verwerfen. Rückruf und Termin klärt die Terminplanung am Lead; offene Vorschläge verfallen nach 14 Tagen.'
            : 'Vorschläge werden erst nach Freigabe übernommen; sichere Ergänzungen erscheinen in der Lead-Historie.'}
        </span>
      </header>
      <AIReviewPanel contactOnly={contactOnly} />
    </div>
  );
}
